export const filterBtnFunctions = () => {
    if (document.body.classList.contains('page-redesign')) return
    const searchWidgets: NodeListOf<HTMLDivElement> = document.querySelectorAll(
        ".search-filters-widget"
    );

    searchWidgets.forEach((searchWidget: HTMLDivElement) => {
        placebtns(searchWidget);
        clonefilterbtns(searchWidget);
        addFilterTitle(searchWidget);
        addOpenClasstoJobfilters(searchWidget);
        setActive(searchWidget);
    });
};

function placebtns(searchWidget) {
    const optionDisplayLists: NodeListOf<HTMLUListElement> =
        searchWidget.querySelectorAll(".option-display-list");

    optionDisplayLists.forEach((optionDisplayList: HTMLUListElement) => {
        const filtbtnContainer = optionDisplayList.querySelector(
            ".apply-filters-btn-container"
        );

        const clearbtn = optionDisplayList.querySelector(
            ".job-filter-buttons-container"
        );

        if (filtbtnContainer && clearbtn) {
            filtbtnContainer.appendChild(clearbtn);
        }
    });
}

function clonefilterbtns(searchWidget) {
    const filterbtns: HTMLDivElement = searchWidget.querySelector(
        ".apply-filters-btn-container"
    );

    const filterList = searchWidget.querySelector(
        ".search-filters-widget__filter-list"
    );

    if (!filterbtns || !filterList) {
        return;
    }

    const clone = filterbtns.cloneNode(true);

    filterList.appendChild(clone);
}

function addFilterTitle(searchWidget) {
    const wrapperheader = searchWidget.querySelector(".filter-heading-wrapper");

    if (!wrapperheader) {
        return;
    }

    const header = document.createElement("h3");
    header.classList.add("filter-heading");

    const text = document.createTextNode("Filters");

    header.appendChild(text);

    wrapperheader.appendChild(header);
}

function addOpenClasstoJobfilters(searchWidget) {
    const filtterheader = searchWidget.querySelector(".filter-heading-wrapper");
    const filterList = searchWidget.querySelector(
        ".search-filters-widget__filter-list"
    );

    if (!filtterheader || !filterList) {
        return;
    }

    filtterheader.addEventListener("click", () => {
        setTimeout(() => {
            if (filtterheader.classList.contains("open")) {
                filterList.classList.add(
                    "search-filters-widget__filter-list--open"
                );
            } else {
                filterList.classList.remove(
                    "search-filters-widget__filter-list--open"
                );
            }
        }, 100);
    });
}

function setActive(searchWidget) {
    searchWidget.classList.add("search-filters-widget--active");
}
